/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type UnansweredCommentsTabContainerLocal = {
    readonly commentsOrderBy: COMMENT_SORT;
    readonly keyboardShortcutsConfig: {
        readonly key: string;
        readonly source: string;
        readonly reverse: boolean;
    } | null;
    readonly " $refType": "UnansweredCommentsTabContainerLocal";
};
export type UnansweredCommentsTabContainerLocal$data = UnansweredCommentsTabContainerLocal;
export type UnansweredCommentsTabContainerLocal$key = {
    readonly " $data"?: UnansweredCommentsTabContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnansweredCommentsTabContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "KeyboardShortcutsConfig",
                    "kind": "LinkedField",
                    "name": "keyboardShortcutsConfig",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "key",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "source",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "reverse",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '19c638cdd24b5d294d07e455815c01df';
export default node;
